/* tslint:disable */
/* eslint-disable */
/**
 * Oil refinery process modeling system
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {mapValues} from '../runtime';
/**
 *
 * @export
 * @interface CalculationResultUpdateOut
 */
export interface CalculationResultUpdateOut {
  /**
   *
   * @type {string}
   * @memberof CalculationResultUpdateOut
   */
  name: string | null;
}

/**
 * Check if a given object implements the CalculationResultUpdateOut interface.
 */
export function instanceOfCalculationResultUpdateOut(
  value: object
): value is CalculationResultUpdateOut {
  if (!('name' in value) || value['name'] === undefined) return false;
  return true;
}

export function CalculationResultUpdateOutFromJSON(json: any): CalculationResultUpdateOut {
  return CalculationResultUpdateOutFromJSONTyped(json, false);
}

export function CalculationResultUpdateOutFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CalculationResultUpdateOut {
  if (json == null) {
    return json;
  }
  return {
    name: json['name']
  };
}

export function CalculationResultUpdateOutToJSON(value?: CalculationResultUpdateOut | null): any {
  if (value == null) {
    return value;
  }
  return {
    name: value['name']
  };
}
